import React from 'react'
import Container from '@material-ui/core/Container'
import {Lefty} from 'Event/template/Lefty'
import {TechCheckProps} from 'Event/Step3/TechCheck'
import StepIndicator from 'Event/template/Lefty/check-in/StepIndicator'
import CheckInPage from 'Event/template/Lefty/check-in/Page'
import Body from 'Event/Step3/TechCheck/Body'
import Buttons from 'Event/Step3/TechCheck/Buttons'
import AdditionalContent from 'Event/Step3/TechCheck/AdditionalContent'
import ConfigFields from 'organization/Event/TechCheckConfig/ConfigFields'

export type LeftyTechCheckProps = TechCheckProps & {
  settings: Lefty['techCheck']
}

export default function TechCheck(props: LeftyTechCheckProps) {
  return (
    <CheckInPage user={props.user}>
      <Container maxWidth="md">
        <StepIndicator step={3} />
        <ConfigFields />
        <Body />
        <Buttons />
        <AdditionalContent />
      </Container>
    </CheckInPage>
  )
}
